// extracted by mini-css-extract-plugin
module.exports = {"aside":"sideMenu-module--aside--2p2bT","ul":"sideMenu-module--ul--1nexh","item":"sideMenu-module--item--2xGRl","Link":"sideMenu-module--Link--296I_"};